import { type Guard } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useFavouriteTeamSelectorGuardStatus } from '@capsicum/socios-core';
import { useCallback } from 'react';

export const useFavouriteTeamSelectorGuard: Guard = () => {
	const { replace } = useRouter();

	return {
		onDenied: useCallback(() => replace('/home'), [replace]),
		status: useFavouriteTeamSelectorGuardStatus()
	};
};
